// set the country selected in the welcome page
// if there is no country in the local store
// will make the field editable
function setCountry(){
  const countryField = document.querySelector('#opt-in input[name="country"]');

  if(localStorage.getItem("country")){
    countryField.value = localStorage.getItem("country");
  }else{
    countryField.readOnly = false;
  }
}

////////////////////////
// validate form fields
function selectMethodMessage(){
  const submitBtn = document.querySelector("#opt-in form input[type='submit']");
  const p = document.createElement("p");
  p.classList.add("err-msg");
  p.innerText = "Please select a communication channel!";

  submitBtn.addEventListener("click", function (e){
    const allCommunicationMethods = document.querySelectorAll("#edit-bottom-left-column .js-form-type-checkbox input");

    for(let i=0; i < allCommunicationMethods.length; i++) {
      // is the checkbox checked
      if (allCommunicationMethods[i].checked) {
        // was error message printed
        if(document.querySelector(".err-msg")){
          // yes, delete it
          document.querySelector(".err-msg").remove();
        }
        // if it is phone verify it
        if(phoneVerification()){
          e.preventDefault();
        }
        //pushTheData(2, document.getElementById("edit-country").value);
        return false;
      }
      p.innerText = translateErrorMessage();
      document.querySelector("#opt-in form").appendChild(p);
    }
    e.preventDefault();
  });
}

function phoneVerification(){
  const allChannelsFields = document.querySelectorAll("#opt-in form input[type='tel']");

  for (let i = 0; allChannelsFields.length > i; i++){
    if(allChannelsFields[i].required){
      //console.log(allChannelsFields[i]);
      if(isValidPhonenumber(allChannelsFields[i].value)){
        //console.log("success");
        allChannelsFields[i].style.borderColor = "#707070";
        if(document.querySelectorAll(".error-modal").length > 0) {
          document.querySelector(".error-modal").remove();
        }
        //return false;
      }else{
        //console.log("doesnt match");
        allChannelsFields[i].style.borderColor = "red";
        addPhonePopup(allChannelsFields[i].parentNode);
      }
    }
  }
}

function isValidPhonenumber(value){
  return value.match(/^\+(?:[0-9]●?){6,20}[0-9]$/);
}

function translateErrorMessage(){
  // get language from url
  const path = window.location.pathname;
  // portuguese
  if(path.search("/pt/") !== -1){
    return "Selecione um canal de comunicação!";
  }
  // default is English
  return "Please select a communication channel!";
}

function addPhonePopup(fieldContainer){
  fieldContainer.style.position = "relative";
  const modal = document.createElement("div");
  modal.classList.add("error-modal");
  const span = document.createElement("span");
  span.innerText = "!";
  modal.appendChild(span);
  const p = document.createElement("p");
  p.innerText = translatePopupMessage();
  modal.appendChild(p);
  fieldContainer.appendChild(modal);
}

function translatePopupMessage(){
  // get language from url
  const path = window.location.pathname;
  // portuguese
  if(path.search("/pt/") !== -1){
    return "Certifique-se de que o seu número está correcto, começando com "+" e o indicativo.";
  }
  // default is English
  return "Please make sure your number is correct, starting with \"+\" and the country code.";
}
/////////////////////////////////////////////
// check checkbox when type in related field
function autoCheck(){
  // email field
  const editableField_email = document.querySelector(".email-address");
  const checkbox_email = document.querySelector(".email-checkbox");
  checkCheckbox(editableField_email, checkbox_email);
  // phone field
  const editableField_phone = document.querySelector(".phone-number");
  const checkbox_phone = document.querySelector(".phone-checkbox");
  checkCheckbox(editableField_phone, checkbox_phone);
  // fax field
  const editableField_fax = document.querySelector(".fax-number");
  const checkbox_fax = document.querySelector(".fax-checkbox");
  checkCheckbox(editableField_fax, checkbox_fax);
}

function checkCheckbox(inputField, checkField){
  inputField.addEventListener("input", function (){
    if(!this.required) {
      checkField.click();
    }
  });
}

////////////////////
// Language switcher
function positionLanguageSwitcher(){
  const theGlobe = document.getElementById("translation-globe");
  const langSwitcher = document.getElementById("block-languageswitcher");

  if (langSwitcher) {
    langSwitcher.style.top = (theGlobe.getBoundingClientRect().top + window.scrollY + 30) + "px";
  }
}

function openLanguageSwitcher(){
  const langSwitcher = document.getElementById("block-languageswitcher");

  if (document.getElementById("translation-globe")) {
    document.getElementById("translation-globe").addEventListener("click", function () {
      if(langSwitcher.classList.contains("open-lang-switcher")) {
        langSwitcher.style.display = "none";
      }else{
        langSwitcher.style.display = "block";
      }
      langSwitcher.classList.toggle("open-lang-switcher");
    });
  }
}

////////////////////////
// Data Layer
function addDataLayer() {
  document.getElementById("proceed-button").addEventListener("click", function () {
    if(!document.getElementById("proceed-button").classList.contains("disabled")) {
      pushTheData(1, localStorage.getItem('country'));
    }
  });
}

function pushTheData(step, country){
  dataLayer.push({
    'event': 'disclaimerComplete',
    'eventStep': 'Step '+step,
    'eventValue': country
  });
}
